export default "__VITE_ASSET__CZ6OmmOG__"